// --- OAuth Redirect helpers (force canonical domains) ---
export const getOAuthOrigin = () => {
  const origin = window.location.origin;

  // Force www in production
  if (origin === "https://maloo.ai") return "https://www.maloo.ai";

  // Allow these as-is
  if (origin === "https://www.maloo.ai") return origin;
  if (origin === "https://staging.maloo.ai") return origin;
  if (origin === "http://localhost:8080") return origin;

  // Fallback: use current origin (useful for previews), but log it
  console.warn("[OAuth] Unexpected origin:", origin);
  return origin;
};

export const buildRedirectUri = (provider: "facebook" | "linkedin" | "google" | "twitter" | "google-drive") =>
  `${getOAuthOrigin()}/app/oauth/${provider}/callback`;